import React from 'react';
import { useLocation } from 'react-router-dom';

import { NextSteps } from './NextSteps';
import { OrderConfirmationDetail } from './OrderConfirmationDetail';
import { useUsers } from "../../user/UserContext";
import { useSettings } from '../../mall_settings/SettingsProvider';

const OrderConfirmation = () => {
    const { pointsOnlyMode } = useSettings();
    const { userData } = useUsers();
    const { state } = useLocation();
    const { lineItems, payment, orderNumber, statement, promoDiscounts = {} } = state;
    const confirmationEmail = pointsOnlyMode ? userData.email : payment.purchaserEmail;

    return (
        <div className="order-confirmation-screen">
            <div className="order-confirmation-screen-left">
                <OrderConfirmationDetail
                    payment={payment}
                    orderNumber={orderNumber}
                    statement={statement}
                    lineItems={lineItems}
                    promotions={promoDiscounts}
                />
            </div>
            <div className="order-confirmation-screen-right">
                <NextSteps confirmationEmail={confirmationEmail} />
            </div>
        </div>
    )
};

export default OrderConfirmation;
